import { render, staticRenderFns } from "./modalProdIncluidos.vue?vue&type=template&id=51fc656c&scoped=true"
import script from "./modalProdIncluidos.vue?vue&type=script&lang=js"
export * from "./modalProdIncluidos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fc656c",
  null
  
)

export default component.exports